import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import CluesPage from "@/pages/clues/page";
import ClueDetailPage from "@/pages/clues/detail/page";
import CategoriesPage from "@/pages/categories/page";
import SubmitPage from "@/pages/submit/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "clues",
        element: <CluesPage />,
      },
      {
        path: "clues/:slug",
        element: <ClueDetailPage />,
      },
      {
        path: "categories",
        element: <CategoriesPage />,
      },
      {
        path: "submit",
        element: <SubmitPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;